import React, { useEffect, useState } from 'react';
import { FadeLoader } from 'react-spinners';
import basedPostUrlRequestLogedIn from '../../../util/apiRequests/basedPostUrlRequestLogedIn';
import styles from './PollingComponent.module.css';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import EditButton from '../../../components/Button/EditButton';
import ValidationIssuesReport from './ValidationIssuesReport';

const defaulteFunc = () => {};
export default function PollingComponent({ handleChangeStatus = defaulteFunc, intl }) {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(false);
  const [stage, setStage] = useState('checking');
  const [requiredFieldsObj, setRequiredFieldsObj] = useState({
    name: '',
    city: '',
    country: '',
    state: '',
    street: '',
    street_number: '',
    postal_code: '',
    phone: '',
  });
  const [requiredData, setRequiredData] = useState([]);

  useEffect(() => {
    let intervalId;
    const checkStatus = async () => {
      try {
        const response = await basedPostUrlRequestLogedIn('/api/check-status/billing-address', {});
        if (response.status === false) {
          setStage('goodToGo');
          setTimeout(() => {
            setStatus(true);
            setLoading(false);
            handleChangeStatus(false);
            setStage('complete');
          }, 1000);
          // clearInterval(intervalId);
        } else if (response.status === true) {
          if (response?.requiredFields.length >= 1) {
            setRequiredData(response?.requiredData);
            const result = response?.requiredFields.reduce((acc, field) => {
              acc[field.name] = requiredFieldsTranslation({ intl })[field.name];
              return acc;
            }, {});
            if (response.isCompany) {
              result.profile = intl.formatMessage({
                id: 'Polling.requieredData.company',
              });
            } else {
              result.profile = intl.formatMessage({
                id: 'Polling.requieredData.personal',
              });
            }
            // console.log('result: ', result);
            setRequiredFieldsObj(prevState => ({
              ...prevState,
              ...result,
            }));
            setStatus(true);
            setLoading(false);
            handleChangeStatus(true);
            setStage('missingInfo');
            clearInterval(intervalId);
          } else {
            handleChangeStatus(true);
            setStatus(false);
            setLoading(true);
            setStage('checking');
          }
        }
      } catch (error) {
        console.error('Error fetching status:', error);
        setStage('error');
      }
    };
    checkStatus();
    // intervalId = setInterval(checkStatus, 1000);
    // return () => clearInterval(intervalId);
  }, []);
  console.log('requiredFieldsObj: ', requiredFieldsObj);
  // const address = { city: undefined, country: 'USA', state: null, street: 'Main St' };
  // const individualAddress = { city: null, country: undefined, state: 'NY', street: '2nd St' };
  // const phoneNumber = undefined;

  // const requiredData = [
  //   {
  //     company: [
  //       { name: 'city', value: address.city },
  //       { name: 'country', value: address.country },
  //       { name: 'state', value: address.state },
  //       { name: 'street', value: address.street },
  //       { name: 'street_number', value: address.street_number },
  //       { name: 'postal_code', value: address.postal_code },
  //       { name: 'phone', value: 'sdlñsldvñsdlñvs' },
  //     ],
  //     individual: [
  //       { name: 'city', value: individualAddress.city },
  //       { name: 'country', value: individualAddress.country },
  //       { name: 'state', value: individualAddress.state },
  //       { name: 'street', value: individualAddress.street },
  //       { name: 'street_number', value: individualAddress.street_number },
  //       { name: 'postal_code', value: individualAddress.postal_code },
  //       { name: 'phone', value: phoneNumber },
  //     ],
  //   },
  // ];
  return (
    <>
      {/* <ValidationIssuesReport requiredData={requiredData} intl={intl} /> */}
      <div className={styles.wrapper}>
        {/* <ValidationIssuesReport requiredData={requiredData} intl={intl} /> */}
        <div className={`${styles.container} ${stage === 'missingInfo' && styles.info}`}>
          <div className={styles.content}>
            {loading || stage === 'goodToGo' ? (
              <div className={styles.loaderContainer}>
                {stage !== 'goodToGo' && (
                  <FadeLoader
                    color="#279D8E"
                    loading={loading}
                    height={15}
                    width={5}
                    radius={2}
                    margin={2}
                  />
                )}
              </div>
            ) : stage === 'missingInfo' ? (
              <ValidationIssuesReport requiredData={requiredData} intl={intl} />
            ) : // <div className={styles.successMessage}>
            //   <p className={styles.message}>
            //     <FormattedMessage
            //       id="BookingDatesForm.CompanyDataRequired"
            //       values={requiredFieldsObj}
            //     />
            //   </p>
            //   <a target="_blank" href="/account/contact-details">
            //     <EditButton
            //       value={intl.formatMessage({
            //         id: `BookingDatesForm.editeError`,
            //       })}
            //     ></EditButton>
            //   </a>
            // </div>
            null}
          </div>
        </div>
      </div>{' '}
    </>
  );
}

const requiredFieldsTranslation = ({ intl }) => {
  return {
    city: intl.formatMessage({
      id: 'Polling.requieredData.city',
    }),
    country: intl.formatMessage({
      id: 'Polling.requieredData.country',
    }),
    state: intl.formatMessage({
      id: 'Polling.requieredData.state',
    }),
    street: intl.formatMessage({
      id: 'Polling.requieredData.street',
    }),
    street_number: intl.formatMessage({
      id: 'Polling.requieredData.street_number',
    }),
    postal_code: intl.formatMessage({
      id: 'Polling.requieredData.postal_code',
    }),
    phone: intl.formatMessage({
      id: 'Polling.requieredData.phone',
    }),
  };
};
